export const FREELANCER_REGISTER_PAGE = () => "/freelancer-register";
export const FREELANCER_STORE_PAGE = () => "/freelancer-store";
export const FREELANCER_HOME_PAGE = () => "/freelancer-home";
export const FREELANCER_STORE_SLOT_PAGE = () => "/freelancer/stores/:storeId";
export const FREELANCER_SCHEDULED_STORES_PAGE = () => "/freelancer/scheduled-stores";
export const FREELANCER_SCHEDULED_STORE_PAGE = () => "/freelancer/scheduled-stores/:storeId";
export const freelancerScheduledStorePath = (storeId: string) =>
  `/freelancer/scheduled-stores/${storeId}`;
export const freelancerStoreSlotPath = (id: string) =>
  `/freelancer/stores/${id}/slots`;
